<div class="scroller">
  <mat-list dense="dense">
    @for (entry of entries$ | async; track entry) {
      <mat-list-item>
        <app-icon mat-list-icon icon="cog"></app-icon>
        <div mat-line>{{ entry.title }}</div>
        <div mat-line>{{ entry.subTitle }}</div>
        <div mat-line>{{ entry.createdAt | date }}</div>
      </mat-list-item>
    }
  </mat-list>
</div>
